import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { set as setNotification } from 'store/notification/actions'
import AlarmDetailsForm from 'UserApp/components/Alarm/AlarmDetailsForm'
import { update, fetchOne } from 'UserApp/store/alarm/actions'
import Loader from 'components/Loader'

class UpdateAlarmModelContainer extends React.PureComponent {
  static propTypes = {
    create: PropTypes.func,
    setNotification: PropTypes.func,
    onClose: PropTypes.func,
    values: PropTypes.object,
    fetchOne: PropTypes.func,
    alarmId: PropTypes.string,
  }

  state = {
    isProcessing: false,
  }

  handleSubmit = async (formData) => {
    const startTime = new Date(formData.alarmDate);
    startTime.setHours(formData.alarmTime.getHours(), formData.alarmTime.getMinutes());
    const payload = {
      startTime: startTime,
      preAlarmReminderMinutes: formData.preAlarmReminderMinutes,
      emergencyNotificationDelayMinutes: formData.emergencyNotificationDelayMinutes,
      locationDetails: formData.locationDetails
    }
    const { update, setNotification, onClose } = this.props
    this.setState({ isProcessing: true })
    try {
      await update(this.props.alarmId, payload)
      setNotification('Alarm saved successfully')
      if (onClose) onClose()
    } catch (error) {
      setNotification('Failed to save alarm details')
      console.error('Error saving alarm details:', error)
    } finally {
      this.setState({ isProcessing: false })
    }
  }

  async componentDidMount() {
    const { fetchOne } = this.props;
    await fetchOne(this.props.alarmId)
  }

  render() {
    const { values } = this.props
    const { isProcessing } = this.state
    return (
      values ? (
        <AlarmDetailsForm
          values={values}
          onSubmit={this.handleSubmit}
          isProcessing={isProcessing}
        />
      ) : (
        <Loader />
      )
    )
  }
}

export default connect(
  (state) => ({
    values: state.alarm?.alarm,
  }),
  {
    update,
    fetchOne,
    setNotification,
  })(UpdateAlarmModelContainer)
